import { render, staticRenderFns } from "./trainingWizardView.vue?vue&type=template&id=5612491c&scoped=true"
import script from "./trainingWizardView.vue?vue&type=script&lang=js"
export * from "./trainingWizardView.vue?vue&type=script&lang=js"
import style0 from "./trainingWizardView.vue?vue&type=style&index=0&id=5612491c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5612491c",
  null
  
)

export default component.exports